import React, { useState, useEffect } from "react";
import "./FourthBannerSlider.css";
import { useSelector } from "react-redux";
import { SendPostRequest } from "../../http";

const FourthBannerSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [homeBanners, setHomeBanners] = useState([]);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    brandingData();
  }, []);

  const brandingData = async () => {
    const siteTheme = sitedata?.options?.theme;
    const response = await SendPostRequest("branding/banners", {
      theme: siteTheme,
    });
    setHomeBanners(response?.data);
    // if (!response?.data || response?.data?.length < 1) {
    //   setIsdata(true);
    // } else {
    //   setHomeBanners(response?.data);
    // }
  };

  const handleSlideChange = (index) => {
    setActiveIndex(index);
  };

  const handlePrevClick = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? homeBanners.length - 1 : prevIndex - 1
    );
  };

  const handleNextClick = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % homeBanners.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % homeBanners.length);
    }, 8000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [homeBanners.length]);

  return (
    <div className="slider-four">
      {homeBanners.map((data, index) => (
        <>
          {data?.banner_category === "custom-text" && (
            <div className="four-shadow"></div>
          )}

          <img
            key={index}
            decoding="async"
            className={`img-slide ${index === activeIndex ? "active" : ""}`}
            src={`${data?.banner_image}`}
            alt={`Slide ${index + 1}`}
          />
        </>
      ))}
      {/* {homeBanners.map((data, index) =>
        data?.banner_category === "custom-text" && (
          <div
            key={index}
            className={`content-text ${index === activeIndex ? "active" : ""
              } ${data?.banner_alignment === "right" ? "align-left" : "align-center"}`}
            style={{ transitionDelay: index === activeIndex ? "1s" : "0s" }}
          >
            <h1 className="animated-text banner-title-font">{data?.banner_title}</h1>
            <p className="animated-text">{data?.banner_description}</p>
          </div>
        )
      )} */}
      {homeBanners.map((data, index) =>
        data?.banner_category === "custom-text" && (
          <div
            key={index}
            className={`content-text ${index === activeIndex ? "active" : ""} ${data?.banner_alignment === "right" ? "align-left" : "align-center"
              }`}
            style={{ transitionDelay: index === activeIndex ? "1s" : "0s" }}
          >
            <div className="containerrr">
              <h1 className="animated-text banner-title-font">{data?.banner_title}</h1>
              <p className="animated-text fourth-banner-description">{data?.banner_description}</p>
            </div>
          </div>
        )
      )}



      <div className="four-slider-navigation">
        <button className="four-prev-btn" onClick={handlePrevClick}>
          &#10094;
        </button>
        <button className="four-next-btn" onClick={handleNextClick}>
          &#10095;
        </button>
        {/* Comment out the dots if not needed
        {homeBanners.map((_, index) => (
          <div
            key={index}
            className={`nav-btn ${index === activeIndex ? "active" : ""}`}
            onClick={() => handleSlideChange(index)}
          ></div>
        ))} */}
      </div>
    </div>
  );
};

export default FourthBannerSlider;
